import { APITypes, OrganizationTypes } from '../primary-record-types';

export const invoiceStatusTypeGuards = {
    open: (
        invoice: OrganizationTypes.OrganizationInvoice,
    ): invoice is OrganizationTypes.OrganizationInvoiceForStatus<'open'> => invoice.status === 'open',
    paid: (
        invoice: OrganizationTypes.OrganizationInvoice,
    ): invoice is OrganizationTypes.OrganizationInvoiceForStatus<'paid'> => invoice.status === 'paid',
    void: (
        invoice: OrganizationTypes.OrganizationInvoice,
    ): invoice is OrganizationTypes.OrganizationInvoiceForStatus<'void'> => invoice.status === 'void',
    refunded: (
        invoice: OrganizationTypes.OrganizationInvoice,
    ): invoice is OrganizationTypes.OrganizationInvoiceForStatus<'refunded'> => invoice.status === 'refunded',
};

export const collaboratorInvoiceStatusTypeGuards = {
    open: (
        invoice: APITypes.organizationService.OrganizationInvoiceDetails,
    ): invoice is APITypes.organizationService.OrganizationInvoiceDetailsForStatus<'open'> => invoice.status === 'open',
    paid: (
        invoice: APITypes.organizationService.OrganizationInvoiceDetails,
    ): invoice is APITypes.organizationService.OrganizationInvoiceDetailsForStatus<'paid'> => invoice.status === 'paid',
    void: (
        invoice: APITypes.organizationService.OrganizationInvoiceDetails,
    ): invoice is APITypes.organizationService.OrganizationInvoiceDetailsForStatus<'void'> => invoice.status === 'void',
    refunded: (
        invoice: APITypes.organizationService.OrganizationInvoiceDetails,
    ): invoice is APITypes.organizationService.OrganizationInvoiceDetailsForStatus<'refunded'> =>
        invoice.status === 'refunded',
};
